const map = {
	"./cs/common.json": 472,
	"./cs/editor.json": 300,
	"./cs/library.json": 4,
	"./cs/projection.json": 716,
	"./cs/selector.json": 880,
	"./en/common.json": 279,
	"./en/editor.json": 943,
	"./en/library.json": 525,
	"./en/projection.json": 139,
	"./en/selector.json": 723,
	"./languages.json": 689,
	"./uk/common.json": 622,
	"./uk/editor.json": 874,
	"./uk/library.json": 474,
	"./uk/projection.json": 738,
	"./uk/selector.json": 878
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 824;